export enum PageTemplate {
    Pdp = "product-detail-page",
    BoxDetail = "box-action-detail-page",
    StoreDetail = "store-detail-page",
    Account = "account-page",
    Checkout = "checkout-page",
    Calculator = "calculator-page",
    Content = "content-page",
    Home = "home-page",
    ProductCategory = "product-category-page",
    Search = "search-page",
    ShoppingCart = "shopping-cart-page",
    BrandDetail = "brand-detail-page",
    Stores = "stores-overview-page",
    Faq = "faq-overview-page",
    FaqCategory = "faq-category-page",
    FaqQuestion = "faq-question-page",
    ContactCustomerService = "contact-page",
    Promotion = "promo-page",
    Outlet = "outlet-page"
}
